<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/sundas-rashid.jpg" alt="Sundas Rashid">
          </figure>
        <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-two.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Sundas Rashid</h2>
      <p class="job-title">Student</p>

      <p class="profile-statement-interviewer">Tell us a little bit about yourself </p>

      <p>I was born in Pakistan but grew up in Italy as I moved there when I was around a year old. Therefore, I have grown up with a horde of multiple cultures around me. I can speak seven languages, 5 of which I can fluently read, write, and speak. Reading and painting are my hobbies which allows me to gain a lot of knowledge that I would not have been able to achieve through academics. I like to sing as well and can do classical Pakistani dance. I love to travel to historical towns and mountainous regions.</p>

      <p class="profile-statement-interviewer">Why Man Met University?</p>

      <p>I did not particularly apply to Man Met with the intention of studying here. I wanted to go to Leeds, however, my mother insisted that I go to Man Met as it is more convenient since I live in Manchester. I was initially against the idea but then realised it was better for me to go here as I can not only live at home but also save money. However, at times I do think about how good of an experience it would have been if I had moved to Leeds.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

      <p>Pakistani culture is very vibrant and distinct thanks to the rich historical background, Islamic nature, geographical location, and ethnic diversity as it is a melting pot of broader Indian subcontinent, Central Asia, and Western influences. Pakistani culture comprises of several ethnic groups coming from regions as far as Africa or Tibet or as close to home as the Indus Valley, which are all very distinct in customs, traditions, historical bloodlines, languages, music and much more. Despite these differences, people in Pakistan live in harmony and welcome people from different backgrounds meaning that racial or cultural biases is not common.</p>


      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students?</p>

      <p>Spreading awareness of different cultures and educating people on different cultures, their customs and values to reduce racial and cultural biases. Celebrating different cultural aspects, traditions or festivals such as on Eid or Diwali, engaging in extra curricular activities to allow people to get an insight to how and why these festivities or traditions exist.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>I am most proud of the way I grew up since it allowed me to not only stay connected to my religion, culture and background but also allowed me to learn about new cultures outside of Pakistan and gain a lot of knowledge and build new skills. It also allowed me to understand the value of certain aspects that other cultures or my own culture lacks.</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

    & figure {
      text-align: right;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>